import React, { DetailedHTMLProps, HTMLAttributes, useEffect } from "react";
import { usePLPContext } from "../../ProductListingPage/ProductListingPage";

import { useMedia } from "react-use"; 
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartPlus,
  faExclamationCircle,
  faHeart as faHeartSolid,
} from "@fortawesome/pro-solid-svg-icons";
import { faHeart, faXmark } from "@fortawesome/pro-regular-svg-icons";
import ProductGallerySlider from './ProductGallerySlider';
import * as classesX from "./ProductCard.module.css";

const classes = classesX;
  
export const VariantSelector = ({ 
    cartState,
    setCartState,
    hit,
    isMedium,
    hasSoonTag,
    canWishlist,
    hasOneVariant,
    canAddToCart,
    isGroupProduct,
    hasPreorderTag,
    selectionText,
    variants,
    Dialog,
    ProductPrice,
    badgeText,
    title,
    subtitle,
    currency,
    messageText,
    hasSizeVariant,
    messageStyles,
    unavailableVariants,
    wishState,
    handleCartClick,
    handleWishClick,
    sanitiseTitle,
    comingSoonSignup,
    womensPhotoPreferred
}) => { 

  const { bundleFunctions, collection, customerTags } = usePLPContext();
  
  // const { utilities } = usePLPContext();
  const soonTagExists = hit.tags.some((tag) => tag.toLowerCase() === "soon" );
  const ignoreSoonTag = soonTagExists && customerTags ? customerTags.some((tag) => tag.toLowerCase().includes('ignore-soon')) : false; // Ignore Soon tag | Meant for Admin product testing.
  const hasColourVariant = hit.options.some(({ name }) => name.toLowerCase() === "colour");
  const variantType = hit.options[0].name;
  const [selectedVariant, setSelectedVariant] = React.useState(`Selected ${variantType.toLowerCase()}`);

  // let variantsTMP = variants
  // variantsTMP.forEach(variant => {
  //   variant.quantity = 0
  //   variant.product_title = title
  //   variant.featured_image = hit.image.src
  //   variant.option_name = hasColourVariant ? 'Colour' : hasSizeVariant ? 'Size' : ''
  // })

  // const [bogoCount, setBogoCount] = React.useState(variantsTMP)
  // const [totalSelected, setTotalSelected] = React.useState(0);

  function filterGalleryImages(){
    let hitImages = hit.images.filter(img => !img.src.includes("ATHLETE_"))

    if(womensPhotoPreferred){
    hitImages.forEach((image, i) => {
        if(image.src.includes("-WOMENS")) {
          hitImages.splice(i, 1)
          hitImages.unshift(image)
        }
      })
    }

    return hitImages
  }

  const totalSelected = () => {
    let count = 0
    let relatedProducts = bundleFunctions?.bundleProducts.filter(prod => prod.product_id == hit.id)
    if(relatedProducts){
      relatedProducts.forEach(prod => {
        count = count + prod.quantity
      })
    }
    return count
  }

  const bundleTag = hit.tags.find((tag) => tag.startsWith("bundle:")) ? hit.tags.find((tag) => tag.startsWith("bundle:")).split(":") : false ;

  const handleAddToDecider = (variant, increment) => {
    if(hasSoonTag){ // If 'Soon' Tag found
      handleWishClick(variant.id)(); // Run Wishlist function
      setCartState((prev) => ({
        ...prev,
        open: false,
      }))
    } else if (bundleFunctions?.bundleType == 'bogo' || bundleFunctions?.bundleType == 'fixed-price-bundle' || bundleFunctions?.bundleType == 'rollover-bundle' ){
      if( bundleFunctions.bundleCanAddMore() || increment < 0 ){
        let variantsTMP = variants
        variantsTMP.forEach((vari, i) => {
 
          const currentBundles = bundleFunctions?.bundleProducts
          const existingVariant = currentBundles.find(ele => ele.id == vari.id)

          vari.quantity = existingVariant != undefined ? existingVariant.quantity : 0
          vari.product_title = title
          vari.featured_image = hit.image.src
          vari.option_name = hasColourVariant ? 'Colour' : hasSizeVariant ? 'Size' : ''

          if(vari.id == variant.id && (vari.quantity != variant.inventory_quantity || increment < 0)){
            //Keep track of total individual variant selected quantites
            variant.quantity = variant.quantity + increment;
          }
        })
        bundleFunctions.updateBundleProducts(variantsTMP)

        setTimeout(()=> {
          setCartState((prev) => ({
            ...prev,
            open: false,
          }))
        },850)
      }
    }else{
      let bundleArray = {}
      if(bundleTag){
        switch(bundleTag[1]){
          case 'bogo':
            bundleArray['_Special'] = 'bogo'
            bundleArray['_Discount'] = bundleTag[2]
            bundleArray['_Key'] = bundleTag[4]
            break;
          case 'fixed':
            bundleArray['_Special'] = 'fixed-price-bundle'
            bundleArray['_Threshold'] = bundleTag[2]
            bundleArray['_Discount'] = bundleTag[3]
            bundleArray['_Key'] = bundleTag[4]
            break;
          case 'rollover':
            bundleArray['_Special'] = 'rollover-bundle'
            bundleArray['_Threshold'] = bundleTag[2]
            bundleArray['_Discount'] = bundleTag[3]
            bundleArray['_Key'] = bundleTag[4]
            break;
        }
      }
      handleCartClick(variant.id, bundleArray); // Otherwise, run Add to Cart function
    } 
  }

  // const soldOut = variants.reduce((accumulator, currentVariant) => accumulator + currentVariant.inventory_quantity, 0) > 0 || hasSoonTag ? true : false;
  
  let buttonText;
  if( hasSoonTag || collection?.forceWishlist ){
    buttonText = 'Add to Wishlist';
  } else if (bundleFunctions?.bundleType == 'bogo' || bundleFunctions?.bundleType == 'fixed-price-bundle' || bundleFunctions?.bundleType == 'rollover-bundle'){
    if (totalSelected() > 0){
      buttonText = `${totalSelected()} Selected`;
    } else {
      buttonText = 'Add to Bundle';
    }
  }else if( hasColourVariant && !hasOneVariant ){
    buttonText = 'Select Colour';
  }else if( isGroupProduct ){ 
    buttonText = selectionText;
  }else if( hasPreorderTag && canAddToCart ){
    buttonText = window.variantStrings.preOrder;
  }else if( !canAddToCart ){
    buttonText = 'Add to Wishlist';
  } else{
    // buttonText = window.variantStrings.addToCart;
    buttonText = ignoreSoonTag ? window.variantStrings.quickAddAdmin : window.variantStrings.quickAdd;
  }


  return (

    <div
      className={classes.cartContainer + ' cartContainer'}
      onMouseLeave={() => {
        isMedium &&
        !hasOneVariant &&
        (canAddToCart || canWishlist) && 
        (isGroupProduct || !isGroupProduct) &&
        setCartState((prev) => ({
          ...prev,
          open: false,
        }))
      }}
    >
      <div className={classes.variantButtonWrapper + ' variantButtonWrapper'}>
        {totalSelected() > 0 &&(
          <>
          {hasOneVariant && !isGroupProduct &&(
            <button 
              className={classes.singleVariantButtonDecrease} 
              onClick={(event) => {
                event.preventDefault();
                let increment = -1
                handleAddToDecider(variants[0], increment);
              }
            }>-</button>
            )}
          </>
        )}
        <button 
          // disabled={ !bundleFunctions.bundleCanAddMore() && !bundleFunctions.productVariantInBundle(hit.id) }
          type="button"
          onClick={(event) => {
            event.preventDefault();
            let increment = +1;
            hasOneVariant && !isGroupProduct
              ? handleAddToDecider(variants[0], increment)
              : setCartState((prev) => ({
                  ...prev,
                  open: true,
                }))
              ;
          }}
          aria-haspopup="dialog"
          aria-label={ hasPreorderTag && canAddToCart ? window.variantStrings.preOrder : ignoreSoonTag ? window.variantStrings.quickAddAdmin : window.variantStrings.quickAdd }
          className={clsx(classes.cartButton + ' cartButton ', {
            fab: !isMedium,
            loading: (
                hasSoonTag // If 'Soon' Tag present
                ? 
                  isMedium && wishState.loading !== null // Check wishState to display
                : 
                  cartState.loading && hasOneVariant // Otherwise check cartState to display
            ),
            "button button--outlined": isMedium,
            hidden: (
              collection?.forceWishlist 
              ?
                !wishState.ready
              :
                hasSoonTag  // If 'Soon' Tag present
                ?
                  !wishState.ready || comingSoonSignup && !collection?.forceWishlist // Hide if wishState is not ready or if coming soon signups is enabled.
                : 
                  !canAddToCart && !hasSoonTag // Otherwise, check if can add to cart
            ), 
          })}
          onMouseEnter={() => {
            isMedium &&
            !hasOneVariant &&
            (canAddToCart || hasSoonTag) &&
            (isGroupProduct || !isGroupProduct) &&
            setCartState((prev) => ({
              ...prev, 
              open: true,
            }));
          }}
        >
          {buttonText}
          {buttonText == 'Quick Add' && (
             <span>+</span>
          )}
        </button>
        {totalSelected() > 0 &&(
          <>
            {/* {hasOneVariant && !isGroupProduct  &&( */}
            {hasOneVariant && 
              !isGroupProduct && 
              bundleFunctions?.bundleProducts.find( ele => ele.id == variants[0].id && ele.quantity > 0 && variants[0].inventory_quantity != ele.quantity) && 
              bundleFunctions.bundleCanAddMore() &&
            (
              <button className={classes.singleVariantButtonIncrease} onClick={(event) => {
                event.preventDefault();
                let increment = 1
                handleAddToDecider(variants[0], increment);}
              }>+</button>
            )}
          </>
        )}
      </div>
      <div
        className={clsx(classes.cartModal + ' cartModal ', {
          [classes.open + ' open']: cartState.open
        })}
      >
        <Dialog
          open={cartState.open}
          onClose={() => {
            setCartState((prev) => ({
              ...prev,
              open: false,
            }));
          }}
          lockScroll={!isMedium}
          className={classes.cartDialog + ' cartDialog'}
        >
          <button
            type="button"
            className={clsx("fab", classes.dialogCloseButton)}
            onClick={(event) => {
              event.preventDefault();
              setCartState((prev) => ({ ...prev, open: false }));
            }}
          >
            <FontAwesomeIcon icon={faXmark} width={16} height={16} />
          </button>

          <div className={classes.dialogHeader}>
            <div className={classes.dialogTitle}>
              <div className="uppercase h4">
                { hasSoonTag ? buttonText : (hasPreorderTag && canAddToCart ? window.variantStrings.preOrder : ignoreSoonTag ? window.variantStrings.quickAddAdmin : window.variantStrings.quickAdd) }
              </div>
            </div>
          </div>

          {!isMedium && (
            <>
              <div className="variant-gallery-slider">
                <ProductGallerySlider 
                  gallery={filterGalleryImages()}
                  preSettings={{
                    dots: false,
                    infinite: false,
                    speed: 500,
                    arrows: false,
                    slidesToShow: 3.5,
                    slidesToScroll: 3
                  }}
                />
              </div>

              <div className={`${classes.dialogItem} info`}>
                {/* <div className={classes.dialogItemImage}>
                  <div className="media media--portrait">
                    <img
                      alt={hit.image?.alt}
                      loading="lazy"
                      src={
                        cartState.open
                          ? window.Shopify.addSizeToImage(hit.image.src, 128)
                          : null
                      }
                      srcSet={
                        cartState.open
                          ? `${window.Shopify.addSizeToImage(
                              hit.image.src,
                              128
                            )} 1x, ${window.Shopify.addSizeToImage(
                              hit.image.src,
                              256
                            )} 2x`
                          : null
                      }
                      width={128}
                      height={160}
                    />
                  </div>
                </div> */}
                  <div className={classes.dialogItemHeader}>
                    <p className={classes.quickBadge}>{badgeText}</p>
                    <p className={classes.dialogItemTitle}>{title}</p>
                    <p className={classes.dialogItemSubtitle}>{subtitle}</p>
                  </div>
                  <ProductPrice product={hit} currency={currency} />
                  {/* <p className={classes.quickMessage} style={messageStyles}>
                    {messageText}
                  </p> */}
              </div>
            
            
              <div className="variant-title">
                <b>{variantType.toUpperCase()}:</b>
                <span>{selectedVariant}</span>
              </div>
            </>
          )}
          <div role="group" className={classes.cartActions + ' cartActions ' + `${!hasSizeVariant ? classes.nonSizeVariant + ' nonSizeVariant' : 'hasSizeVariant'}`}>
            {variants.map((variant) => (
              <div key={variant.id} className={classes.variantHitbntWrapper + ' variantHitbntWrapper'}>
                {(bundleFunctions?.bundleProducts.find( ele => ele.id == variant.id && ele.quantity > 0 )) &&(
                  <button className={classes.decreaseBundleBtn} onClick={(event) => {
                    event.preventDefault();
                    let increment = -1
                    handleAddToDecider(variant, increment);
                  }}>-</button>
                )}
                <button
                  disabled={
                    variant.inventory_policy === "deny" &&
                    !hasSoonTag && variant.inventory_quantity <= 0
                  }
                  key={variant.id}
                  type="button"
                  onClick={(event) => {
                    event.preventDefault();
                    setSelectedVariant(sanitiseTitle(variant.title))

                    let increment = 1
                    handleAddToDecider(variant, increment); 
                  }}
                  className={clsx(classes.hitButton + ' hitButton ' + `${!hasSizeVariant ? classes.nonSizeButtonVariant + ' nonSizeButtonVariant' : 'sizeButtonVariant'}`, {
                    [classes.loading + ' loading']: cartState.loading === variant.id,
                    [classes.isGroupProduct]: isGroupProduct
                  })}
                >
                  {false &&
                  !hasSoonTag &&
                  variant.inventory_policy === "deny" &&
                  variant.inventory_quantity <= 10 &&
                  variant.inventory_quantity > 0 && 
                  !isMedium && ( 
                    <span className={classes.lowStockLabel + ' lowStockLabel'}>
                      {isMedium && (
                        <FontAwesomeIcon
                          width={10}
                          height={10}
                          icon={faExclamationCircle}
                        />
                      )}
                      <span>{window.productStrings.almostGone}</span>
                    </span>
                  )}
                  <div>
                    {sanitiseTitle(variant.title)}
                    {/* {bogoCount.find( ele => ele.id == variant.id && ele.quantity > 0 ) &&(
                      <p className={classes.bubble}>{bogoCount.find( ele => ele.id == variant.id).quantity}</p>
                    )} */}
                    {bundleFunctions?.bundleProducts.find( ele => ele.id == variant.id && ele.quantity > 0 ) &&(
                      <p className={classes.bubble}>{bundleFunctions?.bundleProducts.find( ele => ele.id == variant.id).quantity}</p>
                    )}
                  </div>
                </button>
                {/* {(bogoCount.find( ele => ele.id == variant.id && ele.quantity > 0 && variant.inventory_quantity != ele.quantity )) && bundleFunctions.bundleCanAddMore() &&(
                  <button className={classes.increaseBundleBtn}>+</button>
                )} */}
                
                {(bundleFunctions?.bundleProducts.find( ele => ele.id == variant.id && ele.quantity > 0 && variant.inventory_quantity != ele.quantity )) && 
                  bundleFunctions.bundleCanAddMore() &&
                (
                  <button className={classes.increaseBundleBtn}>+</button>
                )}
                 
              </div>
            ))}
          </div>
        </Dialog>
      </div>
    </div>
  )
}